import { Component, input, ChangeDetectionStrategy } from '@angular/core';

interface Circle {
  percentage: number;
  stroke: string;
}

@Component({
  selector: 'fip-circular-progress',
  templateUrl: './circular-progress.component.html',
  styleUrls: ['./circular-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CircularProgressComponent {
  readonly circles = input<Circle[]>([{ percentage: 100, stroke: 'green' }]);
  readonly activeCircleIndexes = input<number[]>([]);
  readonly circleOpacityActive = input<number>(1);
  readonly circleOpacityInactive = input<number>(0.25);
  readonly label = input<string>('100%');

  isActiveCircle(index: number): boolean {
    return (
      this.activeCircleIndexes().length === 0 ||
      (this.activeCircleIndexes().length > 0 &&
        this.activeCircleIndexes().includes(index))
    );
  }
}
